/* eslint-disable @typescript-eslint/explicit-function-return-type */
import React from "react";
import SignInPage from "./SignInPage";

function Basic() {
  return <SignInPage />;
}

export default Basic;
